(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-rotator')) {
    class AnnouncementRotator extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.announcement-rotator__slide'));
        if (this.slides.length < 2) return;

        this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 5000);
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.hovered = false;
        this.editorLocked = false;

        this.onPause = () => {
          this.hovered = true;
          this.stop();
        };
        this.onResume = (event) => {
          if (event && event.type === 'focusout' && this.contains(event.relatedTarget)) return;
          this.hovered = false;
          this.start();
        };
        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const slide = event.target.closest('.announcement-rotator__slide');
          const slideIndex = this.slides.indexOf(slide);
          if (slideIndex === -1) return;
          this.editorLocked = true;
          this.stop();
          this.show(slideIndex);
        };
        this.onBlockDeselect = (event) => {
          if (!this.contains(event.target)) return;
          this.editorLocked = false;
          this.start();
        };

        this.addEventListener('mouseenter', this.onPause);
        this.addEventListener('mouseleave', this.onResume);
        this.addEventListener('focusin', this.onPause);
        this.addEventListener('focusout', this.onResume);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onBlockSelect) {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }
      }

      start() {
        this.stop();
        if (this.hovered || this.editorLocked) return;
        this.timer = window.setInterval(() => this.next(), this.interval);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      next() {
        if (document.hidden) return;
        this.show((this.index + 1) % this.slides.length);
      }

      show(newIndex) {
        if (newIndex === this.index) return;
        this.slides[this.index].classList.remove('is-active');
        this.index = newIndex;
        this.slides[this.index].classList.add('is-active');
      }
    }

    customElements.define('announcement-rotator', AnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();
})();
